var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 55,
    viewBox: "0 0 70 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6699 27.4826C54.6699 27.455 54.6709 27.4277 54.6709 27.4001C54.6709 12.4182 42.618 0.272949 27.7499 0.272949C16.7261 0.272949 7.25148 6.95077 3.08839 16.51C2.03236 16.3268 0.947187 16.2301 -0.160646 16.2301C-10.6557 16.2301 -19.1637 24.8033 -19.1637 35.3787C-19.1637 45.9541 -10.6557 54.5272 -0.160646 54.5272H56.1556C63.5896 54.5272 69.616 48.4545 69.616 40.9635C69.616 33.4726 63.5896 27.4001 56.1556 27.4001C55.6535 27.4001 55.1579 27.4287 54.6699 27.4826Z",
    fill: "url(#paint0_linear_225_19380)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_19380",
    x1: 25.2261,
    y1: 37.4691,
    x2: 22.0099,
    y2: 14.1692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLeft);
export default __webpack_public_path__ + "static/media/cloud-left.8e2f1d93db0ea43f73cb18eb3bae9462.svg";
export { ForwardRef as ReactComponent };